import { HEADER_INFO, HEADER_MAP, HEADER_MEDIA } from './headerPaths';

export const OFFICE_BASE = '/office';

export const OFFICE_MAP = OFFICE_BASE + HEADER_MAP;
export const OFFICE_INFO = OFFICE_BASE + HEADER_INFO;
export const OFFICE_MEDIA = OFFICE_BASE + HEADER_MEDIA;

export const OFFICE_MEDIA_PICTURE = `${OFFICE_MEDIA}/picture`;
export const OFFICE_MEDIA_LOGO = `${OFFICE_MEDIA}/logo`;
export const OFFICE_MEDIA_BROCHURES = `${OFFICE_MEDIA}/brochures`;
export const OFFICE_MEDIA_VIDEO = `${OFFICE_MEDIA}/video`;
export const OFFICE_MEDIA_VISIT = `${OFFICE_MEDIA}/visit`;

export const OFFICE_BUILDING_DATA = `${OFFICE_INFO}/building`;
